import { Outlet } from "react-router-dom";
import { useSelector } from "react-redux";

import "./layout.css";
import AppLoader from "../../components/AppLoader/appLoader";
import SidebarNavigation from "./SidebarNavigation/SidebarNavigation";

const Layout = () => {
  const { appLoader } = useSelector((state) => state.appLoaderSlice);

  return (
    <>
      <div className="layout-container">
        <div className="sidebar-fixed">
          <SidebarNavigation />
        </div>
        <div className="content-area">
          {appLoader && <AppLoader />}
          <Outlet />
        </div>
      </div>
    </>
  );
};

export default Layout;
